import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Container,
  Row,
  Card,
  CardHeader,
  Label,
} from "reactstrap";
import axios from "axios";
import ReactPaginate from "react-paginate";
import Header from "components/Headers/Header";
import GestionesJuridica from "views/VerGestionesJuridca";
import CrearGestionModal from "./CreaGestionJuridica";
import AenxosJuridica from "views/examples/VerAenxosJuridica";
import { Select } from "antd";

const SolicitudesJuridica = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [estado, setEstado] = useState(""); // Estado seleccionado
  const itemsPerPage = 5;

  useEffect(() => {
    axios
      .get(
        "https://contratosback-dev.azurewebsites.net/api/v1/ObtenerJuridicoCreadas/1"
      )
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error al obtener los datos:", error);
      });
  }, []);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
  };

  const handleEstadoChange = (e) => {
    setEstado(e.target.value);
    setCurrentPage(0); // Reinicia la paginación al cambiar de estado
  };

  const filteredData = data.filter(
    (item) =>
      (item.titulo.toLowerCase().includes(search.toLowerCase()) ||
        item.descripcion.toLowerCase().includes(search.toLowerCase())) &&
      (estado ? item.estado === estado : true) // Filtra por estado si está seleccionado
  );

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const displayedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const postData = (e) => {
    e.preventDefault();
    window.location.href = "/CreaCasosJuridica";
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Solicitudes para gestión</h3>
              </CardHeader>
              <button className="btn btn-primary mb-3" onClick={postData}>
                Crear Un Nuevo Caso
              </button>
              <div className="d-flex justify-content-between mb-3">
                <Input
                  type="text"
                  placeholder="Buscar por título o descripción..."
                  value={search}
                  onChange={handleSearch}
                />
              </div>
              <div className="col">
                <Label for="estadoSelect">Filtrar por estado</Label>
                <select
                  id="estadoSelect"
                  value={estado}
                  onChange={handleEstadoChange}
                  className="ml-12"
                >
                  <option value="">Todos</option>
                  <option value="Nuevos">Nuevos</option>
                  <option value="En Gestión">En Gestión</option>
                  <option value="Resueltos">Resueltos</option>
                </select>
              </div>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Título</th>
                    <th scope="col">Descripción</th>
                    <th scope="col">Tipo Documento</th>
                    <th scope="col">Fecha de Creación</th>
                    <th scope="col">Usuario Creación</th>
                    <th scope="col">Usuario Asignación</th>
                    <th scope="col">Nit</th>
                    <th scope="col">Información Adicional</th>
                    <th scope="col">Trazabilidad</th>
                    <th scope="col">Gestionar</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.id}</td>
                      <td>{item.titulo}</td>
                      <td>{item.descripcion}</td>
                      <td>{item.idTema == 1 ? "Subasta" : item.titulo}</td>
                      <td>
                        {new Date(item.fechaCreacion).toLocaleDateString()}
                      </td>
                      <td>{item.usuarioCreacion}</td>
                      <td>{item.usuarioAsignacion}</td>
                      <td>{item.nit}</td>
                      <td>
                        <AenxosJuridica id={item.id} />
                      </td>
                      <td>
                        <GestionesJuridica id={item.id} />
                      </td>
                      <td>
                        <CrearGestionModal id={item.id} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <ReactPaginate
                previousLabel={<span aria-label="Anterior">&lt;</span>}
                nextLabel={<span aria-label="Siguiente">&gt;</span>}
                breakLabel={"..."}
                pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default SolicitudesJuridica;
